import { Box } from "@mui/material";

const HorizontalFill = () => <Box sx={{ flexGrow: 1 }} />;
export default HorizontalFill;
